<template>
  <section class="section">
    <div class="container">
      <div v-if="isLoggedIn" class="is-clearfix mb-2">
        <button class="button is-text is-pulled-right" @click="logOut">
          Log Out
        </button>
      </div>

      <h1 class="title is-1">
        <span role="img" aria-label="Bar Chart" class="is-block-mobile"
          >📊</span
        >
        <span>Balance Sheet</span>
      </h1>
      <p class="title is-4 is-spaced">
        We help you track your expense, income, and investment. So you can get a
        better understanding of your personal finance.
      </p>
      <p class="subtitle">
        We don't collect any of your financial data. Balance Sheet stores the
        data directly on your Google Drive account.
      </p>
      <div v-if="isLoggedIn" class="buttons are-medium">
        <router-link to="/spreadsheets" class="button is-link">
          Select Spreadsheet
        </router-link>

        <router-link
          v-if="lastOpened"
          :to="`/spreadsheets/${lastOpened.id}`"
          class="button"
        >
          Open {{ lastOpened.title }}
        </router-link>
      </div>

      <button v-else class="button is-link is-medium" @click="logIn">
        Log In with Google
      </button>
    </div>
  </section>
  <footer class="section">
    <div class="container">
      <p>
        Balance Sheet is built by <a href="https://risanb.com">Risan Bagja</a>.
      </p>
    </div>
  </footer>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState({
      isLoggedIn: state => state.auth.isLoggedIn,
      lastOpened: state => state.balanceSheet.lastOpened,
    }),
  },

  methods: {
    ...mapActions('auth', ['logIn', 'logOut']),
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .buttons .button {
    margin-right: 0 !important;
    width: 100%;
  }
}
</style>
